import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
} from "@mui/material";

import { applyPlatformAwareInteractionStyles } from "../../../ui-theme";
import { CounterText } from "../CounterText";
import { IconButton } from "../IconButton";
import { Text } from "../Text";

export interface AccordionProps {
  title: string;
  count?: number;
  expanded: boolean;
  children: React.ReactNode;
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void;
  LinkComponent: React.ElementType;
}

export function Accordion(props: AccordionProps) {
  const { title, expanded, count, children, onChange, LinkComponent } = props;

  return (
    <MuiAccordion expanded={expanded} onChange={onChange}>
      <MuiAccordionSummary
        expandIcon={
          <IconButton
            variant="outlined"
            iconType="chevron-down"
            size="small"
            LinkComponent={LinkComponent}
            sx={(theme) => ({
              // The accordion sets hover states and it stays hovered after click, this causes a styling inconsistency.
              // To fix this, we override the hover state to be the default state
              ...applyPlatformAwareInteractionStyles({
                // Passing empty for hoverStyle since its a required prop, but we just want to set the default style and reset the hover state
                hoverStyle: {},
                defaultStyle: {
                  color: theme.palette.icon?.primary,
                  backgroundColor: theme.palette.background?.tertiary,
                  boxShadow: `inset 0 0 0 ${theme.borderWidth?.regular} ${theme.palette.border!.primary}`,
                },
              }),
            })}
          />
        }
      >
        <CounterText count={count ?? 0}>
          <Text bold variant="h5">
            {title}
          </Text>
        </CounterText>
      </MuiAccordionSummary>
      <MuiAccordionDetails>{children}</MuiAccordionDetails>
    </MuiAccordion>
  );
}
